<template>
  <div>
    <div class="title">
      <h1 style="font-weight: bold;">发票信息</h1>
      <img src="@/assets/imgs/order/3.1 返回1@2x(1).png" alt="" @click="toggleShow">
    </div>
    <div class="commodity-info" v-if="showDetails">
      <div class="message">
        <span class="info-title">公司名称</span>
        <span class="info-value">{{invoiceInfo.invoiceHead}}</span>
      </div>
      <div class="message">
        <span class="info-title">纳税人识别号</span>
        <span class="info-value">{{invoiceInfo.taxpayerIdNo}}</span>
      </div>
      <div class="message">
        <span class="info-title">地址</span>
        <span class="info-value">{{invoiceInfo.invoiceBankName}}</span>
      </div>
      <div class="message">
        <span class="info-title">电话</span>
        <span class="info-value">{{invoiceInfo.invoiceContactTel}}</span>
      </div>
      <div class="message">
        <span class="info-title">开户行</span>
        <span class="info-value">{{invoiceInfo.invoiceBankName}}</span>
      </div>
      <div class="message">
        <span class="info-title">账号</span>
        <span class="info-value">{{invoiceInfo.invoiceAccountNo}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderInvoiceCard",
  data() {
    return {
      radio: "1",
      showDetails: true, // 控制价格详情是否显示
    };
  },
  props: {
    invoiceInfo: Object,
  },
  methods: {
    toggleShow() {
      this.showDetails = !this.showDetails; // 切换显示状态
    },
  }
};
</script>
<style lang="stylus" scoped>
.title {
  margin: 32px 0;
  padding: 0 34px;
  display: flex;
  justify-content: space-between;

  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
  }

  img {
    width: 32px;
    height: 32px;
  }
}

.commodity-info {
  overflow: hidden;
  background-color: #fff;
  margin: 32px 0;
  padding: 0 32px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;

  .message {
    margin: 40px 0;

    .info-title {
      margin-right: 48px;
      color: #666666;
    }

    .info-value {
      color: #333;
    }
  }

  .message-title {
    margin-top: 48px;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
  }
}
</style>